import { render, staticRenderFns } from "./EmpDetails.vue?vue&type=template&id=1b7b854c"
import script from "./EmpDetails.vue?vue&type=script&lang=js"
export * from "./EmpDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports